import React, { Component } from 'react';
import moment from 'moment-timezone';
import './FilterRecords.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions as sessionsActions } from '../../../../Reducks/Sessions';
import { actions as reordingsActions } from '../../../../Reducks/Recordings';
import { getVirtualEvents } from '../../../../Reducks/VirtualEvents/VirtualEventsActions';
import RecordingsTable from '../../../Recordings/Table/RecordingsTable';
import WebinarsTable from '../../../Webinars/Table/WebinarsTable';
import RangeFilter from '../../../Sessions/Filters/SessionsRangeFilter';
import VirtualEventsRangeFilter from '../../../VirtualEvents/Filters/VirtualEventsRangeFilter';
import { RecordingSource, ReportType } from '../../../../Utils/Constants';
import RecordingsDateRangeSelector from '../../../Recordings/Filters/RecordingsDateRangeSelector';
import SessionsDateRangeSelector from '../../../Sessions/Filters/SessionsDateRangeSelector';
import VirtualEventsDateRangeSelector from '../../../VirtualEvents/Filters/VirtualEventsDateRangeSelector';
import WebinarsDateRangeSelector from '../../../Webinars/Filters/WebinarsDateRangeSelector';
import { GENERATE_REPORT } from '../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import SessionsTable from '../../../Sessions/Table/SessionsTable';
import VirtualEventsTable from '../../../VirtualEvents/Table/VirtualEventsTable';
import { getWebinars } from '../../../../Reducks/Webinars/WebinarsActions';

class FilterRecords extends Component {
  static propTypes = {
    reportType: PropTypes.string,
    navigateToReportTypeRow: PropTypes.any,
    isBig: PropTypes.bool.isRequired,
    warningMessage: PropTypes.any
  };
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  render() {
    const { reportType, navigateToReportTypeRow, isBig, warningMessage } = this.props;
    return (
      <div className="filterRecords">
        {navigateToReportTypeRow}
        {!isBig && warningMessage && <div>{warningMessage}</div>}
        <div>{this.getTableForType(reportType)}</div>
      </div>
    );
  }

  getTableForType = reportType => {
    const mixpanelData = {
      action: GENERATE_REPORT,
      reportType: reportType
    };
    switch (reportType) {
      case ReportType.SESSIONS_OVERVIEW_REPORT:
      case ReportType.WEBINAR_ATTENDEE_REPORT:
      case ReportType.WEBINAR_QANDA_REPORT:
      case ReportType.SESSIONS_ATTENDANCE_REPORT:
      case ReportType.WEBINAR_SURVEY_REPORT:
        return (
          <SessionsComponentsContainer
            includeEngagementColumns={false}
            isBig={this.props.isBig}
            mixpanelData={mixpanelData}
          />
        );
      case ReportType.SESSIONS_QANDA_FOLLOW_UP_REPORT:
      case ReportType.WEBINAR_PERFORMANCE_REPORT:
        return (
          <SessionsComponentsContainer
            includeEngagementColumns={true}
            isBig={this.props.isBig}
            mixpanelData={mixpanelData}
          />
        );
      case ReportType.WEBINAR_REGISTRATION_REPORT:
        return <WebinarsComponentsContainer isBig={this.props.isBig} mixpanelData={mixpanelData} />;
      case ReportType.WEBINAR_RECORDING_REPORT:
        return <RecordingsComponentsContainer isBig={this.props.isBig} mixpanelData={mixpanelData} />;
      case ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT:
        return (
          <VirtualEventsComponentsContainer
            includeEngagementColumns={false}
            isBig={this.props.isBig}
            mixpanelData={mixpanelData}
            reportType={reportType}
          />
        );
      case ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT:
        return (
          <VirtualEventsComponentsContainer
            includeEngagementColumns={false}
            isBig={this.props.isBig}
            mixpanelData={mixpanelData}
            reportType={reportType}
          />
        );
      default:
        return null;
    }
  };
}

export default FilterRecords;

export class SessionsComponents extends Component {
  static propTypes = {
    includeEngagementColumns: PropTypes.bool.isRequired,
    reduced_sessions: PropTypes.object,
    isBig: PropTypes.bool.isRequired,
    filterSessions: PropTypes.func,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    })
  };
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  render() {
    const { isBig, mixpanelData, includeEngagementColumns, reduced_sessions, getSessions, filterSessions } = this.props;
    const { t } = this.context;
    return (
      <div className="reportTypeComponents spreadVerticalItems-12">
        {isBig && (
          <div>
            <div className="d-flex justify-content-between align-items-center spreadHorizontalItems-8 ">
              <div className="events-timer">{t('generateReport.wizard.generateEvents')}</div>
              <div className="d-flex">
                <div>
                  <SessionsDateRangeSelector
                    uniqueId={'sessionsDateRangeSelectorInGenerateReportWizard'}
                    mixpanelData={mixpanelData}
                    isBig={true}
                    reduced_sessions={reduced_sessions}
                    getSessions={getSessions}
                  />
                </div>
                <div className={'ve-registrant-range-filter'}>
                  <RangeFilter
                    uniqueId={'sessionsRangeFilterInGenerateReportWizard'}
                    isBig={true}
                    mixpanelData={mixpanelData}
                    reduced_sessions={reduced_sessions}
                    filterSessionsByCount={filterSessions}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <SessionsTable
          uniqueId={'sessionsTableInGenerateReports'}
          isBig={isBig}
          sessionData={reduced_sessions.filterReportSessions}
          includeEngagementColumns={includeEngagementColumns}
          focusedSessionKeyInTable={null}
          focusSessionInChart={() => {}}
          mixpanelData={mixpanelData}
        />
      </div>
    );
  }
}

export const SessionsComponentsContainer = connect(
  state => ({
    reduced_sessions: state.reduced_sessions
  }),
  {
    getSessions: sessionsActions.getSessions,
    filterSessions: sessionsActions.filterSessionsByCount
  }
)(SessionsComponents);

export class WebinarsComponents extends Component {
  static propTypes = {
    reduced_webinars: PropTypes.object,
    isBig: PropTypes.bool,
    filterWebinars: PropTypes.func,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    })
  };
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  render() {
    const { isBig, mixpanelData, reduced_webinars, getWebinars } = this.props;
    const { t } = this.context;
    return (
      <div className="reportTypeComponents spreadVerticalItems-12">
        {isBig && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="events-timer">{t('generateReport.wizard.generateEvents')}</div>
            <WebinarsDateRangeSelector
              uniqueId={'webinarsDateRangeSelectorInGenerateReportWizard'}
              isBig={true}
              reduced_webinars={reduced_webinars}
              getWebinars={getWebinars}
              mixpanelData={mixpanelData}
            />
          </div>
        )}
        <WebinarsTable mixpanelData={mixpanelData} isBig={isBig} uniqueId={'webinarsTableInGenerateReports'} />
      </div>
    );
  }
}

export const WebinarsComponentsContainer = connect(
  state => ({ reduced_webinars: state.reduced_webinars }),
  {
    getWebinars
  }
)(WebinarsComponents);

export class VirtualEventsComponents extends Component {
  static propTypes = {
    reduced_virtual_events: PropTypes.object,
    isBig: PropTypes.bool,
    filterVirtualEvents: PropTypes.func,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    })
  };
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  componentDidMount() {
    const {
      reportType,
      reduced_user: {
        entitlements: { isVirtualEventsEnabled, isVirtualEventsEntitled, isVirtualEventsProvisioned }
      }
    } = this.props;
    const virtualEventsEnabled = isVirtualEventsEnabled && isVirtualEventsEntitled && isVirtualEventsProvisioned;
    if (virtualEventsEnabled) {
      const fromTime = moment()
        .subtract(1, 'year')
        .startOf('day')
        .toISOString();
      const toTime =
        reportType === ReportType.VIRTUAL_EVENT_REGISTRATION_REPORT
          ? moment()
              .add(1, 'year')
              .endOf('day')
              .toISOString()
          : new Date().toISOString();
      this.props.requestVirtualEvents(fromTime, toTime);
    }
  }

  render() {
    const { isBig, mixpanelData, reportType, reduced_virtual_events } = this.props;
    const { t } = this.context;
    const { filter, fetching } = reduced_virtual_events;

    return (
      <div className="reportTypeComponents spreadVerticalItems-12">
        {isBig && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="select-item-header">{t('generateReport.wizard.filterMultipleVirtualEventsTitle')}</div>
            <div className={'ve-date-range-filter'}>
              <div>
                <VirtualEventsDateRangeSelector
                  uniqueId={'virtualEventsDateRangeSelectorInGenerateReportWizard'}
                  isBig={true}
                  mixpanelData={mixpanelData}
                  filter={filter}
                  fetching={fetching}
                  reportType={reportType}
                />
              </div>
              <div className={'ve-registrant-range-filter'}>
                <VirtualEventsRangeFilter
                  uniqueId={'virtualEventsRangeFilterInGenerateReportWizard'}
                  isBig={true}
                  mixpanelData={mixpanelData}
                />
              </div>
            </div>
          </div>
        )}
        {reportType === ReportType.VIRTUAL_EVENT_EXECUTIVE_SUMMARY_REPORT && (
          <div className="virtual-events-timer">{t('generateReport.wizard.generateVirtualEvents')}</div>
        )}
        <VirtualEventsTable mixpanelData={mixpanelData} reportType={reportType} />
      </div>
    );
  }
}

export const VirtualEventsComponentsContainer = connect(
  state => ({
    reduced_virtual_events: state.reduced_virtual_events,
    reduced_user: state.reduced_user
  }),
  {
    requestVirtualEvents: getVirtualEvents
  }
)(VirtualEventsComponents);

export class RecordingsComponents extends Component {
  static propTypes = {
    reduced_recordings: PropTypes.object,
    isBig: PropTypes.bool,
    filterRecordings: PropTypes.func,
    mixpanelData: PropTypes.shape({
      action: PropTypes.string.isRequired,
      reportType: PropTypes.string
    })
  };
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  render() {
    const { isBig, mixpanelData, reduced_recordings, getRecordings } = this.props;
    const { t } = this.context;
    return (
      <div className="reportTypeComponents spreadVerticalItems-12">
        {isBig && (
          <div className="d-flex justify-content-between align-items-center">
            <div className="events-timer">{t('generateReport.wizard.generateEvents')}</div>
            <RecordingsDateRangeSelector
              uniqueId={'recordingsDateRangeSelectorInGenerateReportWizard'}
              isBig={true}
              reduced_recordings={reduced_recordings}
              getRecordings={getRecordings}
              mixpanelData={mixpanelData}
            />
          </div>
        )}
        <RecordingsTable
          isBig={isBig}
          uniqueId={'recordingsTableInReports'}
          recordingsData={reduced_recordings.filterRecordings}
          focusRecordingInChart={() => {}}
          focusedRecordingKeyInTable={null}
          reportSource={[RecordingSource.G2W]}
          mixpanelData={mixpanelData}
        />
      </div>
    );
  }
}

export const RecordingsComponentsContainer = connect(
  state => ({
    reduced_recordings: state.reduced_recordings
  }),
  {
    filterRecordings: reordingsActions.filterRecordingsByCount,
    getRecordings: reordingsActions.getRecordings
  }
)(RecordingsComponents);



// WEBPACK FOOTER //
// ./src/GoToWebinar/GenerateReport/Wizard/Steps/FilterRecords.js